import React from 'react'

const PartialColumnItems = ({ block }) => {
  return (
    <section className={`block ${block._template} ${block.cols ? ' cols-' + block.cols : ''}`}>
      <ul>
        {block.items.map((item, index) => {
          return <li key={index}>
            {item.icon && (
              <img src={item.icon} alt={item.text} title={item.text} loading="lazy" />
            )}
            {item.url ? (
              <a href={item.url}>{item.text}</a>
            ) : (
              <span>{item.text}</span>
            )}
          </li>
        })}
      </ul>
    </section>
  )
}

export default PartialColumnItems
